/** @format */

import React from 'react'
import { Container, Image, Title, Description } from './style'
import notFound from 'assets/images/page-not-found.jpg'
import { useTranslation } from 'react-i18next'

const NotFound = () => {
  const { t } = useTranslation()
  return (
    <Container>
      <Image src={notFound} alt='not found' />
      <Title>{t('not_found')}</Title>
      <Description>{t('not_found_description')}</Description>
    </Container>
  )
}

export default NotFound
